/**
* Based on GitHub Light
*/

.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #24292e;
	--pce-bg: #fff;
	--pce-widget-border: #bfbfbf;
	--pce-widget-bg: #f6f8fa;
	--pce-widget-color: #434d56;
	--pce-widget-color-active: #000;
	--pce-widget-color-options: #5a6772;
	--pce-widget-bg-input: #fafbfc;
	--pce-widget-bg-hover: #b8b8b84f;
	--pce-widget-bg-active: #2188ff33;
	--pce-widget-focus: #007acc;
	--pce-search-match: #ffdf5d66;
	--pce-widget-bg-error: #f2dede;
	--pce-widget-error: #be1100;
	--pce-bg-highlight: #f6f8fa;
	--pce-selection-match: #34d05840;
	--pce-line-number: #1b1f2380;
	--pce-scrollbar: 210, 7%, 55%;
	--pce-bg-fold: #656d76;
	--pce-guide-indent: #1f23281f;
	--pce-ac-icon-class: #953800;
	--pce-ac-icon-constant: #116329;
	--pce-ac-icon-enum: #953800;
	--pce-ac-icon-event: #57606a;
	--pce-ac-icon-function: #6639ba;
	--pce-ac-icon-interface: #953800;
	--pce-ac-icon-keyword: #a40e26;
	--pce-ac-icon-namespace: #a40e26;
	--pce-ac-icon-parameter: #0a3069;
	--pce-ac-icon-property: #953800;
	--pce-ac-icon-snippet: #0550ae;
	--pce-ac-icon-text: #0a3069;
	--pce-ac-icon-unit: #0550ae;
	--pce-ac-icon-variable: #953800;
	--pce-ac-match: #0066bf;
	--pce-tabstop: #0a326433;
	--pce-invisibles: #3333;
	--pce-selection: #add6ff;
	color-scheme: light;
}

.pce-match {
	--pce-search-match: #e9e5ba;
}

.active-line {
	--pce-line-number: #1f2328;
}

.active-indent {
	--pce-guide-indent: #1f23284d;
}

[class*="language-"],
.token.url > .operator,
.token.attr-equals,
.token.punctuation {
	color: #24292e;
}

.token.atrule,
.token.variable,
.language-css .url,
.token.parameter,
.token.list,
.token.maybe-class-name,
.token.class-name {
	color: #e36209;
}

.token.keyword,
.token.atrule .rule,
.token.unit,
.token.deleted,
.token.entity,
.token.selector .combinator,
.token.regex-flags,
.token.token.anchor,
.token.number.quantifier,
.token.operator {
	color: #d73a49;
}

.token.tag,
.token.inserted,
.token.selector,
.token.doctype-tag,
.language-regex .escape {
	color: #22863a;
}

.token.selector .class,
.token.selector .id,
.token.pseudo-class,
.token.pseudo-element,
.token.function {
	color: #6f42c1;
}

.token.attr-value,
.token.string,
.token.char,
.token.regex,
.language-regex,
.token.string-property,
.token.url > .content,
.token.url > .variable {
	color: #032f62;
}

.token.code.keyword {
	color: #24292e;
}

.token.attr-name,
.language-css .token.property,
.token.number,
.token.constant,
.token.color,
.token.boolean,
.token.title.important,
.title.important .punctuation,
.token.property-access,
.token.char-class,
.token.char-set,
.token.doctype,
.token.builtin,
.token.regex .punctuation,
.language-css .token.function,
.token.code.code-snippet {
	color: #005cc5;
}

.token.comment,
.token.prolog,
.token.cdata {
	color: #6a737d;
}

.token.important,
.token.bold {
	font-weight: bold;
}

.token.italic {
	font-style: italic;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-6 {
	color: #0366d6;
}

.token.bracket-level-1,
.token.bracket-level-7 {
	color: #138934;
}

.token.bracket-level-2,
.token.bracket-level-8 {
	color: #b37700;
}

.token.bracket-level-3,
.token.bracket-level-9 {
	color: #cb2431;
}

.token.bracket-level-4,
.token.bracket-level-10 {
	color: #a43276;
}

.token.bracket-level-5,
.token.bracket-level-11 {
	color: #8a3ddb;
}

.token.interpolation-punctuation {
	color: #032f62;
}

.token.bracket-error {
	color: #ff1212cc;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #34d05899, inset 0 0 0 9in #35d05940;
}

.active-tagname,
.word-matches span {
	box-shadow: inset 0 0 0 1px #afb8c199, inset 0 0 0 9in #eaeef280;
}
